import * as types from '../action-types'

const initState = {
    stars: [
        { id: 1, checked: false },
        { id: 2, checked: false },
        { id: 3, checked: false },
        { id: 4, checked: false },
        { id: 5, checked: false }
    ]
}
export default function star(state = initState, action) {
    const { type, data } = action

    switch (type) {
        case types.SET_RATE_STAR:
            return {
                ...state,
                stars: [...data]
            }
        default:
            return state

    }

}